import { render } from "./Dashboard.vue?vue&type=template&id=7ceeb3f3&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=7ceeb3f3&scoped=true&lang=css"

import exportComponent from "/var/www/happy-quiz-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ceeb3f3"]])

export default __exports__